export const VIEWER_URL = process.env.REACT_APP_VIEWER_URL || 'https://viewer.trendads.ai';
export const ADVERTISER_URL = process.env.REACT_APP_ADVERTISER_URL || 'https://advertiser.trendads.ai';
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || 'https://trendads.ai';
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || 'https://admin.trendads.ai';
export const API_URL = process.env.REACT_APP_API_URL || 'http://trendads.ai/api';

const appConfig = {
  VIEWER_URL,
  ADVERTISER_URL,
  MAIN_URL,
  ADMIN_URL,
  API_URL
};

export default appConfig;
